import {Logo} from "components"
import React from "react";

const ListItem = ({group, setCheck = f => f, showAvailableTime = f => f}) => {
    return (
        <li>
            <div className="check-title" id={group.indstCd}>{group.indstNm} <span>{group.count}</span></div>
            {
                group.data.map(item => {

                    console.log("item.isAvailableTime", item.isAvailableTime)
                    const itemIsAvailableTime = item.isAvailableTime;
                    const getOnclick = () => {
                        if (itemIsAvailableTime) {
                            return setCheck(item.insttCd);
                        } else {
                            return showAvailableTime(item);
                        }
                    }
                    const getClassName = () => {
                        if (itemIsAvailableTime) {
                            return `checkMark${item.checked === true ? " on" : ""}`;
                        } else {
                            return "icon icon_question";
                        }
                    }

                    return (
                        <div key={item.insttCd} className="check-list" onClick={getOnclick}>
                            <div>
                                <div>
                                    <div className="img-box img-symbol">
                                        <Logo code={item.insttCd} style={{width: "100%", height: "100%"}}/>
                                    </div>
                                    <p className="ml_10 ellipsis" style={{width: "17rem"}}>{item.insttNm}</p>
                                </div>
                                <div>
                                    {
                                        item.linked && <span className="connect mr_10">연결됨</span>
                                    }
                                    <div className="chk">
                                        <i className={getClassName()}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )

                })
            }
        </li>
    )
}

export default ListItem